import React from 'react';
import PropTypes from 'prop-types';
import PrintProvider, { Print, NoPrint } from 'react-easy-print';
import ZaglavljeTvrtke from './common_components/ZaglavljeTvrtke';
import ZaglavljeKlijenta from './common_components/ZaglavljeKlijenta';
import { Button, Table } from 'semantic-ui-react';
import localization from '../../locales/localization';
import DatumIMjestoObicno from './common_components/DatumIMjestoObicno';
import moment from 'moment';
import FormatIznosa from '../common_components/FormatIznosa';

const styles = {
    container: {
        padding: 24
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    zaglavlja: {
        width: '50%'
    },
    zaglavljeTvrtke: {
        paddingBottom: 24
    },
    poslovnaJedinica: {
        fontSize: 14
    },
    datumImjesto: {
        paddingBottom: 8
    },
    p: {
        fontSize: 10
    },
    title: {
        padding: 12,
        textAlign: 'center'
    },
    table: {
        fontSize: 'xx-small'
    },
    tableCell: {
        paddingTop: 'unset',
        paddingBottom: 'unset'
    },
    tableCellKol: {
        paddingTop: 'unset',
        paddingBottom: 'unset',
        fontFamily: 'monospace'
    },
    tableCellUkupno: {
        paddingTop: 'unset',
        paddingBottom: 'unset',
        verticalAlign: 'top'
    },
    footerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 16,
        paddingBottom: 16
    },
    printButton: {
        textAlign: 'center',
        paddingBottom: 8
    }
};

export default class PotvrdaRezervacije extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            document: JSON.parse(sessionStorage.getItem(this.props.match.params.id))
        };
        this.printDocument = this.printDocument.bind(this);
    }

    printDocument() {
        window.print();
    }

    calculateUkupno(rezervacije) {
        let ukupno = 0;
        rezervacije.forEach(r => {
            ukupno += r.kolicina * r.jedProdajnaCijena;
        });
        return ukupno;
    }

    render() {
        let ukupno = this.calculateUkupno(this.state.document.rezervacije)
        return (
            <PrintProvider>
                <Print>
                    <div style={styles.container}>
                        <div style={styles.headerContainer}>
                            <div style={styles.zaglavlja}>
                                <div style={styles.zaglavljeTvrtke}>
                                    <ZaglavljeTvrtke firma={this.state.document.firma} small={true} />
                                </div>
                                <p style={styles.poslovnaJedinica}>
                                    {localization.printingComponents.common.poslovnaJedinica + ': '}
                                    <b>{this.state.document.poslovnica.naziv}</b>
                                </p>
                                <div style={styles.datumImjesto}>
                                    <DatumIMjestoObicno
                                        datum={moment(this.state.document.datumIVrijeme).format('DD.MM.YYYY.')}
                                        mjesto={this.state.document.poslovnica.naselje}
                                    />
                                </div>
                            </div>
                            <div style={styles.zaglavlja}>
                                <ZaglavljeKlijenta klijent={this.state.document.fizickaOsoba} pokaziBrojTelefona={true} />
                            </div>
                        </div>
                        <div style={styles.title}>
                            <h3>{localization.printingComponents.potvrdaRezervacije.naslov}</h3>
                        </div>
                        <div>
                            <p style={styles.p}>
                                {localization.printingComponents.potvrdaRezervacije.podnaslov.replace('%firma%', this.state.document.firma.ime)}
                            </p>
                        </div>
                        <Table style={styles.table}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell style={styles.tableCell} />
                                    <Table.HeaderCell style={styles.tableCell}>{localization.artikl.sifra}</Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell}>{localization.artikl.naziv}</Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell} textAlign="center" collapsing>
                                        {localization.artikl.mjernaJedinica}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell} textAlign="center" collapsing>
                                        {localization.common.kolicina}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell} textAlign="center" collapsing>
                                        {localization.common.prodajnaCijena}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell} textAlign="center">
                                        {localization.common.vrijediDo}
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.document.rezervacije.map((r, index) => {
                                    return (
                                        <Table.Row key={index}>
                                            <Table.Cell style={styles.tableCell}>{index + 1}</Table.Cell>
                                            <Table.Cell style={styles.tableCell}>{r.predmet.sifra}</Table.Cell>
                                            <Table.Cell style={styles.tableCell}>
                                                <b>{r.predmet.naziv}</b>
                                            </Table.Cell>
                                            <Table.Cell style={styles.tableCell} textAlign="center" collapsing>
                                                {r.predmet.mjernaJedinica}
                                            </Table.Cell>
                                            <Table.Cell style={styles.tableCellKol} textAlign="right" collapsing>
                                                {r.kolicina}
                                            </Table.Cell>
                                            <Table.Cell style={styles.tableCellKol} textAlign="right" collapsing>
                                                <FormatIznosa value={r.kolicina * r.jedProdajnaCijena} />
                                            </Table.Cell>
                                            <Table.Cell style={styles.tableCell} textAlign="center">
                                                {moment(r.datumIsteka).format('DD.MM.YYYY.')}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell style={styles.tableCell} colSpan={4} />
                                    <Table.HeaderCell style={styles.tableCellUkupno} textAlign="center">
                                        <b>{localization.common.ukupno + ':'}</b>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCellKol} textAlign="right" collapsing>
                                        <b>
                                            <FormatIznosa value={ukupno} /><br />
                                        </b>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={styles.tableCell} />
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                        {this.state.document.sluzbenaNapomena ? (
                            <React.Fragment>
                                <br />
                                <div>
                                    <p style={styles.p}>
                                        <b>{localization.printingComponents.common.sluzbenaNapomena + ':'}</b>
                                    </p>
                                    <p style={styles.p}>{this.state.document.sluzbenaNapomena}</p>
                                </div>
                            </React.Fragment>
                        ) : null}
                        <div>
                            <p style={styles.p}>{localization.printingComponents.potvrdaRezervacije.izjavaOsobnaIskaznica}</p>
                            <p style={styles.p}>
                                {localization.printingComponents.potvrdaRezervacije.izjavaDvaPrimjerka
                                    .replace('%naslov%', localization.printingComponents.potvrdaRezervacije.naslov)
                                    .replace('%firma%', this.state.document.firma.ime)}
                            </p>
                            <p style={styles.p}>
                                <b>
                                    {localization.printingComponents.potvrdaRezervacije.izjavaDogovor.replace(
                                        '%naslov%',
                                        localization.printingComponents.potvrdaRezervacije.naslov
                                    )}
                                </b>
                            </p>
                        </div>
                        <br />
                        <br />
                        <p style={styles.p}>{localization.printingComponents.common.dokumentObradenElektronickimPutem}</p>
                        <br />
                        <div style={styles.footerContainer}>
                            <p style={styles.p}>{localization.printingComponents.common.izradio + ':'}</p>
                            <p style={styles.p}>{localization.printingComponents.common.kupac + ':'}</p>
                        </div>
                    </div>
                </Print>
                <NoPrint>
                    <div style={styles.printButton}>
                        <Button color="green" icon="print" size="massive" content={localization.common.ispis} onClick={this.printDocument} />
                    </div>
                </NoPrint>
            </PrintProvider>
        );
    }
}

PotvrdaRezervacije.propTypes = {
    match: PropTypes.object.isRequired
};
